<script setup lang="ts">
import {
  ItinerarySegmentPlaceholderType,
  ItinerarySegmentPlaceholder,
} from '@apps/main/new-desktop/modules/itineraryButton';

import { TransportType } from '@libs/trip-planner-interfaces';

import type { UnavailableItineraryFlightSegment } from '../../../models';
import { useTripOverviewPageStore } from '../../../stores';
import ItineraryTimeline from '../ItineraryTimeline.vue';
import ItineraryTransportSelector from '../ItineraryTransportSelector.vue';

import UnavailableFlightProduct from './UnavailableFlightProduct.vue';
import FlightSegmentHeader from './FlightSegmentHeader.vue';

interface UnavailableFlightSegmentProps {
  segment: UnavailableItineraryFlightSegment;
  shouldHideProductLink: boolean;
}

const props = defineProps<UnavailableFlightSegmentProps>();

interface UnavailableFlightSegmentEmits {
  (eventName: 'remove-filter', id: string): void;
  (eventName: 'show-more-filters'): void;
  (eventName: 'remove-flight'): void;
}

const emit = defineEmits<UnavailableFlightSegmentEmits>();

const tripOverviewPageStore = useTripOverviewPageStore();
</script>

<template>
  <ItineraryTimeline :segment-type="props.segment.segmentType">
    <template #dropdown>
      <ItineraryTransportSelector
        v-if="!props.shouldHideProductLink"
        :transport-type="TransportType.Flight"
        :disabled="false"
        @select-transport="
          tripOverviewPageStore.selectTransport(segment, $event)
        "
      />
      <ItinerarySegmentPlaceholder
        v-else
        :transport-type="ItinerarySegmentPlaceholderType.Flight"
      />
    </template>
    <template #header>
      <FlightSegmentHeader
        :segment="props.segment"
        :print-mode="false"
        :should-hide-product-link="props.shouldHideProductLink"
        @show-more-filters="emit('show-more-filters')"
        @remove-filter="emit('remove-filter', $event)"
        @remove-flight="emit('remove-flight')"
      />
    </template>

    <template #content>
      <UnavailableFlightProduct
        :reasons="props.segment.reasons"
        :message="
          tripOverviewPageStore.getUnavailabilityMessage(
            props.segment.segmentType,
            props.segment.reasons
          )
        "
        @try-another-date="tripOverviewPageStore.scrollToCalendar()"
      />
    </template>
  </ItineraryTimeline>
</template>
